import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'app-e-tax-payment',
    templateUrl: './e-tax-payment.component.html',
    styleUrls: ['./e-tax-payment.component.css'],
    standalone: false
})
export class ETaxPaymentComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {


  }

  onBacktoMainPage() {
    this.router.navigate(["/landing-page"]);
  }

}
